module.exports = __webpack_public_path__ + "static/media/Satwik Polkampally.69ca82c8.png";